import { Button } from "plos/src/components/buttons/Button";
import { IconButton } from "plos/src/components/buttons/IconButton";
import CountryFlag from "plos/src/components/CountryFlag";
import { FormTextField } from "plos/src/components/forms";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useOnboardingContext } from "../../contexts/OnboardingContext";
import EditIcon from "../../img/icons/edit.svg?react";
import {
  editActions,
  editFieldWrap,
  editIcon,
  entryInfo,
  entryName,
  playerInfo,
  playerName,
} from "./playerInfoPanel.css";
import { EditableTeamNamePanelProps } from "./types";

const EditableTeamNamePanel = ({
  region,
  player,
}: EditableTeamNamePanelProps) => {
  const { entryDetails, updateEntryName } = useOnboardingContext();
  const { t } = useTranslation("onboarding");
  const [isEditing, setIsEditing] = useState(false);
  const [draftName, setDraftName] = useState(entryDetails?.name ?? "");

  const teamName =
    entryDetails?.name || t("teamName.placeholder", "Enter Name Here");

  const editLabel = t("teamName.editLabel", "Edit team name");

  const handleEdit = () => {
    setDraftName(entryDetails?.name ?? "");
    setIsEditing(true);
  };

  const handleSave = () => {
    updateEntryName(draftName.trim());
    setIsEditing(false);
  };

  const handleCancel = () => {
    setDraftName(entryDetails?.name ?? "");
    setIsEditing(false);
  };

  return (
    <div className={entryInfo}>
      {isEditing ? (
        <div className={editFieldWrap}>
          <FormTextField
            label={editLabel}
            placeholder={t("teamName.placeholder", "Enter Name Here")}
            value={draftName}
            onChange={setDraftName}
            maxLength={20}
            autoFocus
          />
          <div className={editActions}>
            <Button appearance="error" size="small" onPress={handleCancel}>
              {t("teamName.cancel", "Cancel")}
            </Button>
            <Button
              size="small"
              isDisabled={!draftName.trim()}
              onPress={handleSave}
            >
              {t("teamName.save", "Save")}
            </Button>
          </div>
        </div>
      ) : (
        <div className={playerInfo}>
          <h3 className={entryName}>{teamName}</h3>
          <IconButton
            icon={<EditIcon className={editIcon} aria-hidden="true" />}
            label={editLabel}
            appearance="text"
            onPress={handleEdit}
          />
        </div>
      )}

      <div className={playerInfo}>
        {region && <CountryFlag region={region} />}
        <span className={playerName}>
          {player.first_name} {player.last_name}
        </span>
      </div>
    </div>
  );
};

export default EditableTeamNamePanel;
